import React from 'react';
import { useFormStatus } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {
  AppCancelButton,
  AppSaveButton,
} from '../../buttons/app-button/AppButton';
import { useStyles } from './AppBarWithButtons.styles';

interface IAppBarWithFormStatusButtonsProps {
  cancelLabel?: string;
  submitLabel?: string;
  /** Explicit form id so the submit button only ever submits this form (avoids submitting another form when modal is inside another form context). */
  onSubmitClick?: () => void;
  onCancelClick: () => void;
  /** When true while async submit runs (e.g. Formik), Save shows loading and both buttons are disabled. */
  isSubmitting?: boolean;
}

export function AppBarWithFormStatusButtons({
  onCancelClick,
  cancelLabel,
  submitLabel,
  onSubmitClick,
  isSubmitting = false,
}: IAppBarWithFormStatusButtonsProps) {
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const { pending } = useFormStatus();
  const busy = pending || isSubmitting;

  return (
    <Box className={classes.buttonsWrapper}>
      <AppCancelButton type="button" disabled={busy} onClick={onCancelClick}>
        {cancelLabel ?? t('common.cancel')}
      </AppCancelButton>
      <AppSaveButton disabled={busy} loading={busy} onClick={onSubmitClick}>
        {submitLabel ?? t('common.save')}
      </AppSaveButton>
    </Box>
  );
}
